export default theme => ({
  regionBlock: {
    display: 'inline-block',
    margin: '15px',
    width: 200
  },
  glyph: {
    paddingLeft: 5,
    fontSize: theme.tailleGlyph,
    color: theme.Plan.regionColor
  },
  well: {
    borderWidth: 0,
    borderRadius: 0,
    padding: 0,
    boxShadow: '0px 0px'
  },
  inlineTitle: {
    display: 'inline-block'
  },
  menuElement: {
    height: 50,
    '&:hover': {
      cursor: 'pointer',
      textDecoration: 'none'
    }
  },
  itemCollapsed: {
    backgroundColor: 'white',
    fontSize: 14,
    color: theme.Plan.departmentColor,
    '& a': {
      color: theme.Plan.departmentColor
    }
  }
})
